import * as types from './action-types'

export const backgroundUpdateCurrentRow = rowIndex => ({
  type: types.BG_UPDATE_CURRENT_ROW,
  payload: rowIndex
})

export const updateCurrentRow = (index, delta, st) => ({
  type: types.UPDATE_CURRENT_ROW,
  payload: {
    index,
    delta,
    st,
  }
})



// WEBPACK FOOTER //
// ./src/components/background-canvas/actions.js